<style lang="stylus">
    .InsertWaterMark-mask
        // modal-mask()
        position fixed
        top 0
        left 0
        right 0
        bottom 0
        background-color transparent
        z-index 999
        .InsertWaterMark-modal
            width 360px
            .ivu-icon-ios-arrow-down:before {
              content: "\F33D"
            }
            .InsertWaterMark-container
                // padding-bottom 24px
                .waterMark-radiogroup
                    .waterMark-radio
                        display block
                        height 262px
                    .second-radio {
                        width: 100%;
                        margin-bottom: 24px;
                        height: 16px;
                        display: flex;
                        align-items: center;
                        >span >span{
                            display: block;
                        }
                        >span:last-child {
                            max-width: 300px;
                            display: inline-block;
                            text-wrap: wrap;
                        }
                    }
                .waterMark-setting
                    position absolute
                    top 83px
                    left 24px
                    width calc(100% -  46px)
                    .waterMark-line+.waterMark-line{
                      margin-top 16px
                    }
                    .waterMark-line
                        display flex
                        align-items center
                        height 26px
                        padding-left 29px
                        &.disabled {
                            .waterMark-Dropdown {
                                .waterMark-Dropdown-showbox {
                                    color var(--text-color-ivu-input-disabled)
                                    background-color var(--bg-color-ivu-input-number-input-disabled)!important
                                }
                            }
                        }
                        height 24px
                        padding-left 24px
                        &:nth-last-child(2), &:last-child {
                            height 16px;
                        }
                        .ivu-input{
                          border-color: $box-bordercolor;
                        }
                        .ivu-radio-group{
                          flex-grow: 1;
                          display: flex;
                          justify-content: space-between
                        }
                        .waterMark-span
                            margin-right 10px
                            display inline-block
                            width 50px
                            white-space nowrap
                            flex-shrink 0
                        .ivu-select-dropdown
                            max-height 400px
                            overflow-y auto
                            @media screen and (max-height:820px)
                                max-height 378px
                            @media screen and (max-height:768px)
                                max-height 266px
                        .waterMark-Dropdown
                            width 100%
                            &.ban
                                pointer-events none
                                color #bebebe
                            &.short
                                width 100px
                            .waterMark-Dropdown-showbox
                                position relative
                                width 200px
                                border 1px solid $box-bordercolor
                                font-size 12px
                                padding-left 10px
                                height 24px
                                line-height 24px
                                i
                                    position absolute
                                    right 5px
                                    top 6px
                            .long-showbox
                                width 100%
                                border-radius $box-radius
                            .short-showbox
                                width 100px
                                border-radius $box-radius
                        .waterMark-colorbox
                            position relative
                            display inline-block
                            width 100px
                            height 24px
                            border 1px solid $box-bordercolor
                            border-radius: $box-radius;
                            cursor pointer
                            vertical-align middle
                            &.disabled
                                cursor not-allowed
                                .waterMark-colorbox-color
                                    pointer-events none
                            .waterMark-colorbox-color
                                position absolute
                                top 2px
                                left 2px
                                width 94px
                                height 18px
                                border 1px solid rgba(0,0,0,0.1)
                                border-radius: 4px;
                            .waterMark-colorbox-color.white
                                outline 2px solid #ccc
                        .waterMark-checkbox
                            margin-left 20px
                            span{
                              margin-right: 3px
                            }
                    .waterMark-setting-mask
                        position absolute
                        left 0
                        top 0
                        bottom 0
                        right 0
                        background-color rgba(255,255,255,.8)
                        cursor not-allowed
                        z-index 1
</style>

<template>
    <div class="InsertWaterMark-mask">
        <Dialog
            class="InsertWaterMark-modal"
            :title="$t('InsertWaterMark')"
            :isShow="true"
            :showVipIcon="!Boolean(vip) && typeRadio !== 1"
            :hoverShowVipIcon="!Boolean(vip) && !isUsedVipState && hasWatermarkInit"
            showFooter="true"
            @ok="confirm"
            @close="handleClose"
        >
            <div class="InsertWaterMark-container">
                <RadioGroup class="waterMark-radiogroup" :disabled="typeRadio !== 0" v-model="typeRadio">
                    <Radio class="waterMark-radio" :label="0">
                        <span>{{ $t("fontWaterMark") }}</span>
                    </Radio>
                    <template v-if="!Boolean(vip) && isUsedVipState">
                        <Radio :label="1">
                            <span>{{ $t("noWaterMark") }}</span>
                        </Radio>
                    </template>
                    <Radio :label="1" class="second-radio" v-else>
                        <span>{{ $t("noWaterMark") }}</span>
                    </Radio>
                </RadioGroup>
                <div class="waterMark-setting">
                    <div class="waterMark-line" :class="{ disabled: typeRadio !== 0 }">
                        <span class="waterMark-span">{{ $t("text") }}：</span>
                        <Input class="waterMark-input" v-model="curData.text" :disabled="typeRadio !== 0" type="text" :size="'small'" />
                    </div>
                    <div class="waterMark-line" :class="{ disabled: typeRadio !== 0 }">
                        <span class="waterMark-span">{{ $t("font") }}：</span>
                        <Dropdown trigger="click" class="waterMark-Dropdown" @on-click="setFamily" :class="{ ban: typeRadio !== 0 }">
                            <div class="waterMark-Dropdown-showbox long-showbox">
                                <span v-text="family[curData.fontIndex]"></span>
                                <Icon type="ios-arrow-down"></Icon>
                            </div>
                            <DropdownMenu slot="list">
                                <DropdownItem v-for="(item, index) in family" :key="index" :style="{ fontFamily: item }" :name="index">
                                    {{ item }}
                                </DropdownItem>
                            </DropdownMenu>
                        </Dropdown>
                    </div>
                    <div class="waterMark-line" :class="{ disabled: typeRadio !== 0 }">
                        <span class="waterMark-span">{{ $t("fontSize") }}：</span>
                        <Dropdown
                            trigger="click"
                            class="waterMark-Dropdown short"
                            @on-click="setTextSize"
                            :class="{ ban: typeRadio !== 0 || banSize }"
                        >
                            <div class="waterMark-Dropdown-showbox short-showbox">
                                <span v-text="$t(size[curData.sizeIndex])"></span>
                                <Icon type="ios-arrow-down"></Icon>
                            </div>
                            <DropdownMenu slot="list">
                                <DropdownItem v-for="(item, index) in size" :key="index" :name="index">
                                    {{ $t(item) }}
                                </DropdownItem>
                            </DropdownMenu>
                        </Dropdown>
                    </div>
                    <div class="waterMark-line" :class="{ disabled: typeRadio !== 0 }">
                        <span class="waterMark-span">{{ $t("fontStyle") }}：</span>
                        <div class="waterMark-colorbox" :class="{ disabled: typeRadio !== 0 }">
                            <div
                                class="waterMark-colorbox-color"
                                :class="{ white: color == '#ffffff' }"
                                :style="{ backgroundColor: color }"
                                @click="showColor($event)"
                            ></div>
                        </div>
                        <Checkbox class="waterMark-checkbox" :disabled="typeRadio !== 0" v-model="curData.transparent">{{ $t("opacity") }}</Checkbox>
                    </div>
                    <div class="waterMark-line" :class="{ disabled: typeRadio !== 0 }">
                        <span class="waterMark-span">{{ $t("format") }}：</span>
                        <RadioGroup v-model="curData.waterMarkPositionType2" @on-change="positionTypeChange">
                            <Radio :label="0" :disabled="typeRadio !== 0">
                                <span>{{ $t("horizontal") }}</span>
                            </Radio>
                            <Radio :label="1" :disabled="typeRadio !== 0">
                                <span>{{ $t("diagonal") }}</span>
                            </Radio>
                            <Radio :label="2" :disabled="typeRadio !== 0">
                                <span>{{ $t("repeat") }}</span>
                            </Radio>
                        </RadioGroup>
                    </div>
                    <div class="waterMark-line" :class="{ disabled: typeRadio !== 0 }">
                        <span class="waterMark-span">{{ $t("pos") }}：</span>
                        <RadioGroup v-model="curData.posMode">
                            <Radio :label="1" :disabled="typeRadio !== 0">
                                <span>{{ $t("front") }}</span>
                            </Radio>
                            <Radio :label="0" :disabled="typeRadio !== 0">
                                <span>{{ $t("back") }}</span>
                            </Radio>
                            <div :style="`width: ${lang === 'zh' ? '69px' : '50px'}`"></div>
                        </RadioGroup>
                    </div>
                    <div class="waterMark-setting-mask" v-if="false && typeRadio !== 0"></div>
                </div>
            </div>
        </Dialog>
    </div>
</template>

<script lang="ts">
    import { Component, Prop, Vue, Watch } from "vue-property-decorator";
    import Dialog from "./Dialog.vue";
    declare var InsertWaterMark: any;
    @Component({
        components: {
            Dialog,
        },
    })
    export default class InsertInsertWaterMark extends Vue {
        size: Array<string> = ["auto", "36", "40", "48", "72", "96", "105", "120", "144", "168", "220", "260", "300", "360"];
        family: Array<string> = [
            "Arial",
            "Arial Black",
            "Book Antiqua",
            "Bookman Old style",
            "Calibri",
            "Calibri Light",
            "Cambria",
            "Candara",
            "Century",
            "Century Gothic",
            "Comic Sans MS",
            "Consolas",
            "Constantia",
            "Corbel",
            "Courier New",
            "Franklin Gothic Medium",
            "Garamond",
            "Georgia",
            "Lucida Sans Unicode",
            "Malgun Gothic",
            "Meiryo",
            "Microsoft JhengHei",
            "MS Gothic",
            "MS Mincho",
            "MS PGothic",
            "MS PMincho",
            "PMingLiU-ExtB",
            "sans-serif",
            "Segoe UI",
            "Segoe UI Light",
            "Sylfaen",
            "Tahoma",
            "TH SarabunPSK",
            "Times",
            "Times New Roman",
            "Trebuchet MS",
            "Verdana",
            "仿宋",
            "楷书",
            "隶书",
            "微软雅黑",
            "黑体",
            "宋体",
            "华文楷体",
            "华文行楷",
            "华文新魏",
        ];
        enFamily: string[] = [
            "Arial",
            "Arial Black",
            "Book Antiqua",
            "Bookman Old style",
            "Calibri",
            "Calibri Light",
            "Cambria",
            "Candara",
            "Century",
            "Century Gothic",
            "Comic Sans MS",
            "Consolas",
            "Constantia",
            "Corbel",
            "Courier New",
            "Franklin Gothic Medium",
            "Garamond",
            "Georgia",
            "Lucida Sans Unicode",
            "Malgun Gothic",
            "Meiryo",
            "Microsoft JhengHei",
            "MS Gothic",
            "MS Mincho",
            "MS PGothic",
            "MS PMincho",
            "PMingLiU-ExtB",
            "Segoe UI",
            "Segoe UI Light",
            "Sylfaen",
            "Tahoma",
            "TH SarabunPSK",
            "Times",
            "Times New Roman",
            "Trebuchet MS",
            "Verdana",
        ];
        zhFamily: string[] = ["仿宋", "楷书", "隶书", "微软雅黑", "黑体", "宋体", "华文楷体", "华文行楷", "华文新魏"];

        typeRadio: number = 1;
        curData = {
            text: "",
            fontIndex: 0,
            sizeIndex: 0,
            transparent: true,
            waterMarkPositionType2: 0,
            posMode: 0, // 0是底层  1是顶层
        };
        // 导进来的 | 其他端保存 的文件是否有水印
        hasWatermarkInit: boolean = false;
        prevData = {
            typeRadio: 1,
            text: "",
            fontIndex: 0,
            sizeIndex: 0,
            color: "",
            transparent: true,
            layoutMode: 0,
            posMode: 0,
        };

        showColor(e) {
            let node = e.target;
            let payload = {
                type: this.fmtType.OnceColor,
                index: 10,
            };
            this.$store.commit("setColor", payload);
            this.$nextTick(() => {
                this.$store.dispatch("usePalette", { e, type: "OnceColor" });
            });
        }
        setFamily(name) {
            this.curData.fontIndex = name;
        }
        setTextSize(name) {
            this.curData.sizeIndex = name;
        }
        get fmtType() {
            return this.$store.state.ui.fmtType;
        }
        get color() {
            return this.$store.state.ui.onceColor;
        }

        @Watch("curData", { deep: true })
        watchCurData(newVal, oldVal) {
            this.setData(true);
        }

        @Watch("color")
        watchColor(newVal, oldVal) {
            this.setData(true);
        }

        @Watch("typeRadio")
        watchTypeRadio(newVal, oldVal) {
            this.setData(true);
        }

        setData(preview = false) {
            let obj = {
                waterMarkType: this.typeRadio === 0 ? 2 : 0,
                waterMarkText: this.curData.text,
                waterMarkFamily: this.family[this.curData.fontIndex],
                waterMarkSize: this.curData.sizeIndex ? parseInt(this.size[this.curData.sizeIndex]) : -1,
                waterMarkColor: this.color,
                waterMarkTransparent: this.curData.transparent,
                waterMarkPositionType: this.curData.waterMarkPositionType2,
                waterMarkPosMode: this.curData.posMode,
            };
            let oldObj = {
                waterMarkType: this.prevData.typeRadio === 0 ? 2 : 0,
                waterMarkText: this.prevData.text,
                waterMarkFamily: this.family[this.prevData.fontIndex],
                waterMarkSize: this.prevData.sizeIndex ? parseInt(this.size[this.prevData.sizeIndex]) : -1,
                waterMarkColor: this.prevData.color,
                waterMarkTransparent: this.prevData.transparent,
                waterMarkPositionType: this.prevData.layoutMode,
                waterMarkPosMode: this.prevData.posMode,
            };
            window["_view"].setWatermark(obj, oldObj, preview);
            if (!preview && !window.EDCONFIG.IS_SDK) {
                if (!this.vip && obj.waterMarkType != 0) {
                    this.sensors.track("tryVipBenefit", {
                        Catalogues: "editFileProcess",
                        trial_vip_benefit: "customMark",
                    });
                }
            }
        }
        clearData() {
            this.typeRadio = 0;
            this.curData.text = "";
            this.curData.fontIndex = 0;
            this.curData.sizeIndex = 0;
            this.curData.transparent = true;
            this.curData.waterMarkPositionType2 = 0;
            this.$store.commit("setStatus", {
                type: "onceColor",
                data: "#FFFFFF",
            });
        }
        confirm() {
            // if (!this.vip && (this.typeRadio !== 1 || this.hasWatermarkInit)) {
            //     this.$openBuyPage("customMark");
            //     return;
            // }
            this.setData();
            this.clearData();
            this.closeModal();
        }

        handleClose(type) {
            if (type === "close") {
                this.confirm();
            } else {
                let obj = {
                    waterMarkType: this.prevData.typeRadio === 0 ? 2 : 0,
                    waterMarkText: this.prevData.text,
                    waterMarkFamily: this.family[this.prevData.fontIndex],
                    waterMarkSize: this.prevData.sizeIndex ? parseInt(this.size[this.prevData.sizeIndex]) : -1,
                    waterMarkColor: this.prevData.color,
                    waterMarkTransparent: this.prevData.transparent,
                    waterMarkPositionType: this.prevData.layoutMode,
                    waterMarkPosMode: this.prevData.posMode,
                };
                window["_view"].setWatermark(obj, obj, true);
                this.clearData();
                this.closeModal();
            }
        }
        closeModal() {
            this.$store.commit("setDialogState", {
                type: "showDialog",
                data: false,
            });
        }
        get isUsedVipState() {
            return this.$store.getters.isUsedVipState;
        }
        banSize = false;
        positionTypeChange(e) {
            if (e == 2) {
                this.banSize = true;
                this.curData.sizeIndex = 0;
            } else {
                this.banSize = false;
            }
        }
        mounted() {
            if (this.lang == "zh") {
                this.family = this.zhFamily.concat(this.enFamily);
            } else {
                this.family = this.enFamily.concat(this.zhFamily);
            }
            let watermark = window["_view"]._doc._watermark;
            if (watermark) {
                this.hasWatermarkInit = watermark._type === 0 ? false : true;
                let warterType = watermark._type === 0 ? 1 : 0,
                    text = watermark._text,
                    fontIndex = this.family.indexOf(watermark._fontName),
                    sizeIndex = watermark._fontSize === -1 ? 0 : this.size.indexOf(watermark._fontSize + ""),
                    color = watermark._textClr,
                    transparent = watermark._transparency !== 255,
                    layoutMode = watermark._layoutMode,
                    posMode = watermark._posMode;

                // 0选中水印,1选中无水印
                this.typeRadio = warterType;
                this.curData.text = text;
                this.curData.fontIndex = fontIndex;
                this.curData.sizeIndex = sizeIndex;
                this.$store.commit("setStatus", {
                    type: "onceColor",
                    data: color,
                });
                this.curData.transparent = transparent;
                this.curData.waterMarkPositionType2 = layoutMode;
                this.curData.posMode = posMode;
                if (this.curData.waterMarkPositionType2 == 2) {
                    this.banSize = true;
                }

                this.prevData.typeRadio = warterType;
                this.prevData.text = text;
                this.prevData.fontIndex = fontIndex;
                this.prevData.sizeIndex = sizeIndex;
                this.prevData.color = color;
                this.prevData.transparent = transparent;
                this.prevData.layoutMode = layoutMode;
                this.prevData.posMode = posMode;
            } else {
                this.$store.commit("setStatus", {
                    type: "onceColor",
                    data: "#DCDCDC",
                });
            }
        }

        created() {}
    }
</script>
<i18n>
{
  "zh": {
    "InsertWaterMark": "插入水印",
    "urlTitle": "网址",
    "fontWaterMark": "文字水印",
    "text": "文字",
    "font": "字体",
    "fontSize": "字号",
    "fontStyle": "样式",
    "auto": "自动",
    "opacity": "半透明",
    "format": "版式",
    "horizontal": "水平",
    "diagonal": "对角线",
    "repeat": "平铺",
    "noWaterMark": "无水印",
    "pos": "位置",
    "front": "顶层",
    "back": "底层",
    "confirm": "确定",
    "cancel": "取消",
    "tryWaterMark": "会员特权试用水印"
  },
  "en": {
    "InsertWaterMark": "Insert Watermark",
    "urlTitle": "URL",
    "text": "Text",
    "font": "Font",
    "fontSize": "Size",
    "fontStyle": "Style",
    "confirm": "OK",
    "cancel": "Cancel",
    "fontWaterMark": "Text Watermark",
    "auto": "Automatic",
    "opacity": "Opacity",
    "format": "Format",
    "horizontal": "Horizontal",
    "diagonal": "Diagonal",
    "repeat": "Repeat",
    "noWaterMark": "No Watermark",
    "pos": "Position",
    "front": "Top",
    "back": "Bottom",
    "tryWaterMark": "Watermark appears for premium trial"
  },
  "fr": {
    "InsertWaterMark": "Insérer un Filigrane",
    "urlTitle": "URL",
    "fontWaterMark": "Filigrane de Texte",
    "text": "Texte",
    "font": "Police",
    "fontSize": "Taille",
    "fontStyle": "Style",
    "auto": "Automatique",
    "opacity": "Translucide",
    "format": "Format",
    "horizontal": "Horizontal",
    "diagonal": "Diagonal",
    "repeat": "Répéter",
    "noWaterMark": "Pas de filigrane",
    "pos": "Position",
    "front": "Haut",
    "back": "Bas",
    "confirm": "Confirmer",
    "cancel": "Annuler",
    "tryWaterMark": "Un filigrane s'affiche pour l'essai Premium"
  },
  "de": {
    "InsertWaterMark": "Wasserzeichen einfügen",
    "urlTitle": "URL",
    "fontWaterMark": "Text Wasserzeichen",
    "text": "Text",
    "font": "Font",
    "fontSize": "Größe",
    "fontStyle": "Style",
    "auto": "Automatisch",
    "opacity": "Opacity",
    "format": "Format",
    "horizontal": "Horizontal",
    "diagonal": "Diagonal",
    "repeat": "Wiedergeben",
    "noWaterMark": "Kein Wasserzeichen",
    "pos": "Position",
    "front": "Oben",
    "back": "Unten",
    "confirm": "Sichern",
    "cancel": "Abbrechen",
    "tryWaterMark": "Wasserzeichen werden in der Premium-Testversion angezeigt"
  },
  "jp": {
    "InsertWaterMark": "透かしを挿入",
    "urlTitle": "インターネットアドレス",
    "confirm": "OK",
    "cancel": "キャンセル",
    "fontWaterMark": "テキスト透かし",
    "text": "テキスト",
    "font": "フォント",
    "fontSize": "サイズ",
    "fontStyle": "スタイル",
    "auto": "自動",
    "opacity": "半透明",
    "format": "レイアウト",
    "horizontal": "水平",
    "diagonal": "対角線",
    "repeat": "繰り返す",
    "noWaterMark": "透かしなし",
    "pos": "位置",
    "front": "上",
    "back": "下",
    "tryWaterMark": "プレミアムの試用版では透かしが入ります"
  },
  "es": {
    "InsertWaterMark": "Insertar marca de agua",
    "urlTitle": "URL",
    "fontWaterMark": "Texto Marca de Agua",
    "text": "Texto",
    "font": "Font",
    "fontSize": "Tamaño",
    "fontStyle": "Estilo",
    "auto": "Automático",
    "opacity": "Opacidad",
    "format": "Formato",
    "horizontal": "Horizontal",
    "diagonal": "Diagonal",
    "repeat": "Repetir",
    "noWaterMark": "Sin Marca de Agua",
    "pos": "Posición",
    "front": "Superior",
    "back": "Inferior",
    "confirm": "Aceptar",
    "cancel": "Cancelar",
    "tryWaterMark": "En la prueba de Premium aparece una marca de agua"
  },
  "pt": {
    "InsertWaterMark": "Inserir Marca de Água",
    "urlTitle": "URL",
    "text": "Texto",
    "font": "Fonte",
    "fontSize": "Tamanho",
    "fontStyle": "Estilo",
    "confirm": "OK",
    "cancel": "Cancelar",
    "fontWaterMark": "Marca de Água de Texto",
    "auto": "Automático",
    "opacity": "Opacidade",
    "format": "Formato",
    "horizontal": "Horizontal",
    "repeat": "Repita",
    "diagonal": "Diagonal",
    "noWaterMark": "Sem Marca de Água",
    "pos": "Posição",
    "front": "Acima",
    "back": "Abaixo",
    "tryWaterMark": "A marca d'água é exibida para a avaliação premium"
  },
  "it": {
    "InsertWaterMark": "Inserisci Filigrana",
    "urlTitle": "URL",
    "text": "Testo",
    "font": "Font",
    "fontSize": "Dimensioni",
    "fontStyle": "Stile",
    "confirm": "OK",
    "cancel": "Annulla",
    "fontWaterMark": "Testo Filigrana",
    "auto": "Automatico",
    "opacity": "Opacità",
    "format": "Formato",
    "horizontal": "Orizzontale",
    "diagonal": "Diagonale",
    "repeat": "Ripeti",
    "noWaterMark": "Nessuna Filigrana",
    "pos": "Posizione",
    "front": "In alto",
    "back": "In basso",
    "tryWaterMark": "La filigrana viene visualizzata nella versione di prova Premium"
  },
  "tw": {
    "InsertWaterMark": "插入浮水印",
    "urlTitle": "網址",
    "fontWaterMark": "文字浮水印",
    "text": "文字",
    "font": "字型",
    "fontSize": "大小",
    "fontStyle": "樣式",
    "auto": "自動",
    "opacity": "半透明",
    "format": "版式",
    "horizontal": "水平",
    "diagonal": "對角線",
    "repeat": "重複",
    "noWaterMark": "無浮水印",
    "pos": "",
    "front": "",
    "back": "",
    "confirm": "確定",
    "cancel": "取消",
    "tryWaterMark": "Premium 試用的浮水印"
  },
  "kr": {
    "InsertWaterMark": "워터마크 삽입",
    "urlTitle": "URL",
    "fontWaterMark": "텍스트 워터마크",
    "text": "텍스트",
    "font": "글씨체",
    "fontSize": "크기",
    "fontStyle": "스타일",
    "auto": "자동",
    "opacity": "불투명도",
    "format": "포맷",
    "horizontal": "수평",
    "diagonal": "대각선",
    "repeat": "반복",
    "noWaterMark": "워터마크 없음",
    "pos": "",
    "front": "",
    "back": "",
    "confirm": "확인 ",
    "cancel": "취소 ",
    "tryWaterMark": "프리미엄 평가판에는 워터마크가 표시됨"
  }
}
</i18n>
